module.exports = __webpack_public_path__ + "img/shangchuan-.21913502.png";